import { call, put, select, takeEvery } from "redux-saga/effects";
import { callApi, callApiWithNoAuth } from "../../api/Api";
import {
  stopLoading,
  showErrorMessage,
  startLoading,
} from "../layout/action";
import { setSystemAlert, GET_SYSYTEM_ALERT } from "./action";

export function* callSystemAlert(action) {
  try {
    if (action.payload === "clientadmin") return;
    const { loginState } = yield select();

    yield put(startLoading());
    const stateResponse = yield call(callApiWithNoAuth, {
      method: "GET",
      url: `/portal/pages/home-without-session/alert/portal-message`,
    });
    const { data } = stateResponse;
    yield put(setSystemAlert(data));
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(showErrorMessage({ error: err, title: "Get System Alert" }));
  }
}
export function* watchSystemAlert() {
  yield takeEvery(GET_SYSYTEM_ALERT, callSystemAlert);
}
